// import produce from 'immer'
// import React, { useEffect, useState } from 'react'
// import { useSelector, useDispatch } from 'react-redux'
// import { useRouteMatch, useHistory } from 'react-router-dom'
// import IterminalTableComponent from '../../../../components/table/IterminalTableComponent'
// import { FilterModel } from '../../../../models/utils/filterModel'
// import { FilterOptionModel } from '../../../../models/utils/filterOption'
// import { filtersSetRequest } from '../../../../store/filter/actions'
// import { getFilters } from '../../../../store/filter/selectors'
// import {
//   compensationApplicationsFilters,
//   fileRegistrationColumns,
// } from '../../../../utils/metaData'
// import { getPageCount } from '../../../../utils/tableFunctions'
// import gsdDataService from '../../../../services/compensationRecommendation/compensation/gsdService'
// import CompensationApplicationsFilter from '../../../../components/filters/CompensationApplicationsFilter'
// import {
//   defaultPageLimit,
//   defaultOrderListLimit,
// } from '../../../../utils/constants'
// const GsdApplication = () => {
//   const filterOption = {
//     descending: true,
//     limit: defaultPageLimit,
//     orderFields: defaultOrderListLimit,
//   } as FilterModel
//   const [filter, setFilter] = useState(filterOption)
//   const [pageCount, setPageCount] = useState(0)
//   const [dataCount, setDatacount] = useState(0)
//   const [state, setstate] = useState([])
//   const [loading, setLoading] = useState(true)
//   const filters = useSelector(getFilters)
//   const { path } = useRouteMatch()
//   const history = useHistory()
//   const dispatch = useDispatch()

//   useEffect(() => {
//     dispatch(filtersSetRequest({ filters: compensationApplicationsFilters }))
//     async function getApplicationFiles() {
//       await retriveDataCountAndData(filter)
//       setLoading(false)
//     }
//     getApplicationFiles()
//   }, [])
//   const columns = React.useMemo(() => fileRegistrationColumns, [])

//   const retriveApplicationFilesData = async (pageDetails: any) => {
//     setLoading(true)
//     const newFilter = produce(filter, (draft) => {
//       draft.page = pageDetails.pageIndex + 1
//     })
//     setFilter(newFilter)
//     const applicationData = await gsdDataService.apiFetchGsdList(newFilter)
//     setstate(applicationData.data)
//     setLoading(false)
//   }

//   const retriveFilterData = async (selectedFilters: FilterOptionModel[]) => {
//     console.log(selectedFilters)
//     setLoading(true)
//     const newFilter = produce(filter, (draft) => {
//       draft.page = 1
//       draft.filterData = selectedFilters
//     })
//     setFilter(newFilter)
//     await retriveDataCountAndData(newFilter)
//     setLoading(false)
//   }

//   async function retriveDataCountAndData(filterData: FilterModel) {
//     const applicationCountData = await gsdDataService.apiFetchGsdListCount(
//       filterData
//     )
//     if (applicationCountData.status === 200) {
//       setDatacount(applicationCountData.data.count)
//       setPageCount(
//         getPageCount(applicationCountData.data.count, filterOption.limit)
//       )
//       const applicationData = await gsdDataService.apiFetchGsdList(filterData)
//       setstate(applicationData.data)
//     } else {
//       setDatacount(0)
//       setPageCount(0)
//       setstate([])
//     }
//   }

//   const handleView = (id: number) => {
//     history.push(`${path}view/${id}`)
//   }

//   return (
//     <>
//       {!loading && (
//         <div className="mb-4">
//           <CompensationApplicationsFilter
//             scheme="GSD"
//             filterData={filters}
//             onFilter={(e: FilterOptionModel[]) => {
//               dispatch(filtersSetRequest({ filters: e }))
//               retriveFilterData(
//                 e.filter(
//                   (filter: FilterOptionModel) => filter.selected === true
//                 )
//               )
//             }}
//           />
//         </div>
//       )}
//       <div>
//         <IterminalTableComponent
//           columns={columns}
//           data={state}
//           fetchData={retriveApplicationFilesData}
//           loading={loading}
//           pageCount={pageCount}
//           totalCount={dataCount}
//           onClickRow={(row: any) => {
//             handleView(row.id)
//           }}
//         />
//       </div>
//     </>
//   )
// }

// export default GsdApplication

import { AdvancedFilterModel } from '../../../../models/utils/filterModel'
import { useRouteMatch, useHistory } from 'react-router-dom'
import AdvancedSearchTable from '../../../../components/table/advancedSearchTable/AdvancedSearchTable'
import { applicationCommonColumns } from '../../../../components/table/advancedSearchTable/AdvancedSearchTableUtil'
import { defaultPageLimit } from '../../../../utils/constants'

const GsdApplication = () => {
  // Define initial filter options
  const initFilterOption = {
    filterValue: null,
    limit: defaultPageLimit,
    page: 1,
    orderBy: 'created_date_time', // Replace with the actual default sorting column
    order: 'DESC',
  } as AdvancedFilterModel

  const { path } = useRouteMatch()
  const history = useHistory()

  // Function to handle row clicks and navigate to the view page
  const handleView = (id: number) => {
    history.push(`${path}view/${id}`)
  }

  return (
    <>
      <AdvancedSearchTable
        initFilterOption={initFilterOption} // Pass the initialized filter option
        columns={applicationCommonColumns} // Replace with the actual columns if different
        dataApiPath={'/compensation-recommendation/compensation/gsd/view/list'} // Provide the actual data API path
        countApiPath={
          '/compensation-recommendation/compensation/gsd/view/count'
        } // Provide the actual count API path
        onClickRow={(row: any) => {
          handleView(row.id)
        }}
      />
    </>
  )
}

export default GsdApplication
